import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  getDetailInterviewStart,
  getDetailInterviewSuccess,
  getDetailInterviewFailed,
} from "../redux/getDetailInterview";
import { toast } from "react-toastify";
import { updateFormDetailInterview } from "../redux/formDetailInterview";
import { getDetailInterviewApi } from "core/http/service/interviewSchedule";

function* getDetailInterviewWork(
  action: ReturnType<typeof getDetailInterviewStart>
) {
  try {
    const res = yield call(getDetailInterviewApi, action.payload);
    yield put({ type: getDetailInterviewSuccess.type });
    yield put({
      type: updateFormDetailInterview.type,
      payload: {
        ...res,
        listCvResponse: (res?.listCvResponse || [])?.map((it) => ({
          ...it,
          appearancePoint: String(it?.appearancePoint || 0),
          implementationPlanPoint: String(it?.implementationPlanPoint || 0),
          demeanorPoint: String(it?.demeanorPoint || 0),
          communicatePoint: String(it?.communicatePoint || 0),
          experiencePoint: String(it?.experiencePoint || 0),
          expertiseKnowledgePoint: String(it?.expertiseKnowledgePoint || 0),
        })),
      },
    });
  } catch (error) {
    yield put({
      type: getDetailInterviewFailed.type,
    });
    if (error?.response?.data?.businessError) {
      toast.error(error?.response?.data?.businessError?.[0].message);
    } else {
      toast.error("Đã có lỗi xảy ra!");
    }
  }
}

function* watchGetDetailInterview() {
  yield takeLatest(getDetailInterviewStart.type, getDetailInterviewWork);
}
export default function* getDetailInterviewSaga() {
  yield all([watchGetDetailInterview()]);
}
